import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,//Added for edit functionality
  Menu,//Added for edit functionality
  MenuItem,//Added for edit functionality
  Typography,
  Box,
  Grid,
  Avatar,
  Button,
} from '@mui/material';
import { fetchUserNameById } from '../DatabaseApis/DBQuery';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';


// Component for displaying card details in a dialog
const CardDetailsDialog = ({ open, onClose, card, readOnly = true,   onEdit,firestore ,columns}) => {
  
  // Simple check: if card status is "Done", disable editing
  const isDone = card?.cardStatus === 'Done';

  //console.log('Card status:', card?.cardStatus);
  //console.log('Is Done?', isDone);

  // State variables to hold the usernames of the user who created and updated the card
  const [createdByUserName, setCreatedByUserName] = useState(null);
  const [updatedByUserName, setUpdatedByUserName] = useState(null);
  
//adding the edit functionality here:
const [anchorEl, setAnchorEl] = useState(null);
const handleMenuOpen  = (e) => setAnchorEl(e.currentTarget);
const handleMenuClose = () => setAnchorEl(null);

const handleEditClick = () => {//edit function
  handleMenuClose();        // close the ︙ menu
  onEdit && onEdit(card);   // tell parent “edit this card”
};


  useEffect(() => {
    const fetchUserNames = async () => {
      if (card) {
        const createdBy = await fetchUserNameById(card.cardCreatedByUserId);
        const updatedBy = await fetchUserNameById(card.cardUpdatedByUserId);
        
        setCreatedByUserName(createdBy);
        setUpdatedByUserName(updatedBy);
      }
    };
  
    fetchUserNames();
  }, [card]);

  if (!card) return null; // Ensure card is defined before rendering

  /**
   * Formats timestamp to a consistent format: DD/MMM/YYYY, HH:MM:SS AM/PM
   */
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    
    // Split the date and time parts
    const [datePart, timePart] = formattedDate.split(', ');
    // Replace spaces with forward slashes in date part only
    return `${datePart.replace(/ /g, "/")}, ${timePart}`;
  };

  /**
   * Generates display information for a user
   */
  const getUserDisplayInfo = (user) => {
    const displayName = user.authorEmail || 'Anonymous';
    const initials = displayName.split('@')[0].charAt(0).toUpperCase();
    const role = user.role || 'User';
    const userGroup = user.userGroup || 'Standard';
    
    return {
      displayName,
      initials,
      role,
      userGroup
    };
  };

  // Filter out deleted comments
  const activeComments = card.comments ? card.comments.filter(comment => !comment.isDeleted) : [];

  return (
   <Dialog
open={open}
  onClose={readOnly ? () => {} : onClose}
  disableEscapeKeyDown={readOnly}
  maxWidth="md"
  fullWidth
>

      <Box
  sx={{
    background: 'linear-gradient(45deg, #1e88e5 30%, #66bb6a 90%)',
    color: '#fff',
    fontWeight: 'bold',
    textAlign: 'center',
    position: 'relative'           // allow absolute positioning
  }}
>
  <DialogTitle sx={{ p: 2, color: 'white' }}>
    Card Details

{readOnly && (
  <>
    {/* Edit Button - hidden if card is in "Done" column */}
    {!isDone && (
      <IconButton
        onClick={handleEditClick}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8, 
          color: 'white',
        }}
      >
        <EditIcon />
      </IconButton>
    )}

    {/* Cancel / Close Button */}
    <IconButton
      onClick={onClose}
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,//added to the left corner opposite of edit icon
        color: 'white',
      }}
    >
      <CloseIcon />
    </IconButton>
  </>
)}




  </DialogTitle>
</Box>


      <DialogContent>
        <Grid container spacing={2}>
          {/* Display various card details */}
          {/* Task Name */}
          <Grid item xs={12}>
            <Typography variant="h6">{card.taskName}</Typography>
          </Grid>

          {/* Task ID Changed to Card ID */}
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Card ID:</strong> {card.cardId}</Typography>
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Description:</strong> {card.description || 'N/A'}</Typography>
          </Grid>

          {/* Assignee Name */}
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Assignee:</strong> {card.assigneeName || 'N/A'}</Typography>
          </Grid>

          {/* Priority */}
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Priority:</strong> {card.priority || 'N/A'}</Typography>
          </Grid>

          {/* Status */}
          <Grid item xs={12}>
            <Typography variant="body1"><strong>Status:</strong> {card.cardStatus || 'N/A'}</Typography>
          </Grid>

          {/* Due Date */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Due Date:</strong> {card.dueDate ? new Date(card.dueDate).toLocaleDateString() : 'N/A'}
            </Typography>
          </Grid>

          {/* Estimate */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Estimate:</strong> {card.estimate ? `${card.estimate} hrs` : 'N/A'}
            </Typography>
          </Grid>

          {/* Acceptance Criteria */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Acceptance Criteria:</strong> {card.acceptanceCriteria || 'N/A'}
            </Typography>
          </Grid>

          {/* Assign Date */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Assign Date:</strong> {card.assignDate ? new Date(card.assignDate).toLocaleDateString() : 'N/A'}
            </Typography>
          </Grid>

          {/* Subtasks */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Subtasks:</strong> 
              {card.subtasks && card.subtasks.length > 0 
                ? card.subtasks.map((subtask, index) => (
                    <div key={index}>
                      {subtask.name} {subtask.completed ? '(Completed)' : '(Not Completed)'}
                    </div>
                  ))
                : 'N/A'}
            </Typography>
          </Grid>

          {/* Attachments */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Attachments:</strong>
            </Typography>
            {card.files && card.files.length > 0 ? (
              <Box sx={{ pl: 2, mt: 1 }}>
                {card.files.map((file) => (
                  <Box
                    key={file.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      py: 1,
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <Typography
                      component="a"
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ 
                        color: '#4e54c8',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      {file.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {new Date(file.uploadedAt).toLocaleDateString()}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ pl: 2, mt: 1 }}>
                No attachments
              </Typography>
            )}
          </Grid>

          {/* Comments */}
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Comments:</strong>
              {activeComments.length > 0 
                ? activeComments.map((comment) => {
                    const { displayName, initials, role, userGroup } = getUserDisplayInfo(comment);
                    return (
                      <Box key={comment.id} sx={{ mt: 1, display: 'flex', gap: 1 }}>
                        <Avatar 
                          sx={{ 
                            width: 24, 
                            height: 24,
                            bgcolor: (role === 'Admin' || role === 'Tenant Admin') ? '#d32f2f' : '#4e54c8'
                          }}
                        >
                          {initials}
                        </Avatar>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body2">
                              <strong>{displayName}</strong>
                            </Typography>
                            
                          </Box>
                          <Typography variant="caption" color="text.secondary">
                            {formatTimestamp(comment.timestamp)}
                            {comment.isEdited && ' (edited)'}
                          </Typography>
                          <Typography variant="body2">
                            {comment.text}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })
                : ' N/A'}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CardDetailsDialog;